import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69eac87263911b0014dce30b/softphonesaas/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69eac87263911b0014dce30b/softphonesaas/src/app/login/components/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69eac87263911b0014dce30b/softphonesaas/src/components/ui/AppLogo.tsx");
